import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkDataTable from "../../components/molecules/TkDataTable";
import { Box, Typography } from "@mui/material";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkButton from "../../components/atoms/TkButton";
import {
  httpIAPI_CON014,
  httpIAPI_CON023,
  httpIAPI_CON030,
  httpIAPI_CON031,
} from "./api/request";
import { IAPI_CON014_Response } from "../../type/apiType";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { GlobalContext } from "../../context/globalContext";
import {
  contextText,
  fakeTableList,
  infoHeadTitleList,
  infoModalMessage,
  schema,
  stepperData,
} from "./parts";
import { ConfirmStatus, FacilityKind } from "../../assets/data/Constants";
import { BusinessContext } from "../../context/businessContext";
import { useNavigate } from "react-router";
import TkDialog from "../../components/atoms/TkDialog";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import { changeAmountFormat } from "../../utils/useTools";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * SCRC050110 契約解除（中小企業退職金共済契約締結）内容入力
 * @return SCRC050110 契約解除（中小企業退職金共済契約締結）内容入力
 */
const SCRC050110 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { state, setState } = useContext(GlobalContext);

  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [resData, setResData] = useState<any>();
  const [contractDate, setContractDate] = useState<string>();
  const [modalOpen, setModalOpen] = useState(true);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [staffNoInfoList, setStaffNoInfoList] = useState<any[]>();
  const [formData, setFormData] = useState<any>();
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(false);
  const [nextBtnDisabled, setNextBtnDisabled] = useState<boolean>(true);
  const formRef = useRef<{ getAllValue: () => any; submit: () => any }>(null);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState?.common?.contractorNo
    : state.authInfo?.contractorNo;
  const applyId = location.state?.applyId ?? businessState?.job_03?.applyId;
  const [openWarning, setOpenWarning] = useState(false);

  // 初期化
  const handleInit = async () => {
    try {
      const res = await httpIAPI_CON023({
        applyId: applyId,
        contractorNo,
      });

      setResData(res);
      let resArr = stateFakeTableList.current;

      if (res.resultCd === "I0000") {
        const contractDate = resArr.find(
          (item) => item.keyword === "contractDate"
        )!;
        const isBtnDisabled = !!res.contractDate && res.tempSaveStep === 9;

        const hasCertificate =
          res.facilityList?.every(
            (facility) =>
              facility.threeMonthsRetireCertificate ===
              facility.threeMonthsRetire
          ) ?? false;
        setNextBtnDisabled(!(isBtnDisabled && hasCertificate));

        setIsBtnDisabled(isBtnDisabled);
        contractDate.setDefaultValue = res.contractDate;
        contractDate.onGetInputValue = (e: any) => {
          setContractDate(e.target.value);
        };
        contractDate.disabled = isBtnDisabled;

        const contractNo = resArr.find(
          (item) => item.keyword === "contractNo"
        )!;

        contractNo.setDefaultValue = res.contractNo;

        contractNo.disabled = isBtnDisabled;

        const contractReason = resArr.find(
          (item) => item.keyword === "contractReason"
        )!;
        contractReason.setDefaultValue = res.contractReason;
        contractReason.disabled = isBtnDisabled;

        const remark = resArr.find((item) => item.keyword === "remark")!;
        remark.setDefaultValue = res.remark;
        remark.disabled = isBtnDisabled;

        let facilitySituationTable = resArr.find(
          (item) => item.keyword === "facilitySituationTable"
        )!;

        const infoBodyList = funInfoBodyList(
          res.facilityList!,
          !isBtnDisabled,
          res.contractDate!
        );
        facilitySituationTable.node = (
          <TkDataTable
            bodyList={infoBodyList}
            count={infoBodyList.length}
            defaultRowsPerPage={10}
            headList={infoHeadTitleList}
            headerLeftComponent={labelids.labelid.LBLC050110_02}
            pagin
          />
        );

        let infoManual = resArr.find((item) => item.keyword === "infoManual3")!;
        infoManual.node = (
          <Box className="SCRC050110infoManual3">
            <Typography>{labelids.labelid.LBLC050110_03}</Typography>
          </Box>
        );
        resArr.find((item) => item.keyword === "dateConfirmBtn")!.node = (
          <Box className="buttonArea">
            <TkButton
              disabled={isBtnDisabled}
              onClick={() => handleConfirmDate()}
            >
              締結年月日確定
            </TkButton>
          </Box>
        );

        setStateTableList([...resArr]);
        setBusinessState({
          ...businessState,
          job_03: {
            ...businessState.job_03,
            applyId: res.applyId,
            tempSaveStep: res.tempSaveStep,
          },
        });

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setIsBtnDisabled(true);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleConfirmDate = () => {
    const formData = formRef.current?.getAllValue() || {};
    // 必須チェック
    if (
      !formData.contractDate ||
      !formData.contractNo ||
      !formData.contractReason
    ) {
      formRef.current?.submit?.();
      return;
    }
    if (
      formData.contractReason &&
      // eslint-disable-next-line no-control-regex
      !/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/.test(
        formData.contractReason
      )
    ) {
      return;
    }
    if (
      formData.remark &&
      // eslint-disable-next-line no-control-regex
      !/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/.test(formData.remark)
    ) {
      return;
    }

    if (formData.contractNo && !/^[!-~]*$/.test(formData.contractNo)) {
      return;
    }
    const errorCheck = businessCheck(formData.contractDate);
    setState({
      ...state,
      errorMsgId: errorCheck,
    });
    if (errorCheck) return;

    const contractDate = new Date(formData.contractDate).setHours(0, 0, 0, 0);
    const today = new Date();
    const nextYearDate = new Date(
      today.setFullYear(today.getFullYear() + 1)
    ).setHours(0, 0, 0, 0);

    if (contractDate >= nextYearDate) {
      //入出力項目.中小企業退職共済契約締結年月日 ≧ システム日付 + 1年
      setOpenWarning(true);
    } else {
      handleCallNotificationUpdate();
    }
  };

  const handleCallNotificationUpdate = async () => {
    const formData = formRef.current?.getAllValue() || {};
    try {
      // 中小企業退職金共済契約締結届更新API 呼び出し
      const res = await callAPI_CON014(formData, "CONFIRM");

      if (res.resultCd === "I0000") {
        setBusinessState({
          ...businessState,
          job_03: {
            ...businessState.job_03,
            applyId: res.applyId,
          },
        });

        const hasCertificate =
          res.facilityList?.every(
            (facility) =>
              facility.threeMonthsRetireCertificate ===
              facility.threeMonthsRetire
          ) ?? false;

        setNextBtnDisabled(!hasCertificate);
        setIsBtnDisabled(true);
        let resArr = stateFakeTableList.current;
        resArr.find((item) => item.keyword === "contractDate")!.disabled = true;
        resArr.find((item) => item.keyword === "contractNo")!.disabled = true;
        resArr.find((item) => item.keyword === "contractReason")!.disabled =
          true;
        resArr.find((item) => item.keyword === "remark")!.disabled = true;
        resArr.find((item) => item.keyword === "dateConfirmBtn")!.node = (
          <Box className="buttonArea">
            <TkButton disabled={true}>締結年月日確定</TkButton>
          </Box>
        );

        if (res?.facilityList) {
          let facilitySituationTable = resArr.find(
            (item) => item.keyword === "facilitySituationTable"
          )!;
          const infoBodyList = funInfoBodyList(
            res?.facilityList,
            false,
            formData.contractDate
          );
          facilitySituationTable.node = (
            <TkDataTable
              bodyList={infoBodyList}
              count={infoBodyList.length}
              defaultRowsPerPage={10}
              headList={infoHeadTitleList}
              headerLeftComponent={labelids.labelid.LBLC050110_02}
              pagin
            />
          );
        }
        setStateTableList([...resArr]);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        return;
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    !modalOpen && handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  // 業務チェック
  const businessCheck = (date: any): string => {
    let errorMsg = "";
    const confirmStatus = state.authInfo?.confirmStatus;
    const fiscalYear = state.authInfo?.fiscalYear!;
    const inputDate = dayjs(date);
    if (
      !(
        confirmStatus === ConfirmStatus["確定済"] ||
        confirmStatus === ConfirmStatus["過去年度"]
      )
    ) {
      // 当年度の確定前、かつ入出力項目.中小企業退職共済契約締結年月日 ≦ 前年度末（３月３１日）
      if (inputDate.isBefore(dayjs(fiscalYear + "/04/01"))) {
        errorMsg = "TKMSG_SCR0089E";
      }
    }
    return errorMsg;
  };

  const handleSubmit = async (data: any, index: any) => {
    switch (index) {
      case 0: // 一時保存
        try {
          const res = await callAPI_CON014(data, "TEMPSAVE");
          if (res.resultCd === "I0000") {
            setBusinessState({
              ...businessState,
              job_03: {
                ...businessState.job_03,
                applyId: res?.applyId,
                tempSaveStep: 1,
              },
            });
            setOpen(true);
            setState({
              ...state,
              errorMsgId: "",
            });
          } else {
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });
            return;
          }
        } catch (error) {
          navigate("/error");
        }
        break;

      case 1: // 次へ
        try {
          const res = await httpIAPI_CON031({
            contractorNo: isKiko
              ? businessState.common?.contractorNo!
              : state.authInfo?.contractorNo!,
            businessType: businessState.common?.businessType!,
            applyId: applyId,
          });
          if (res.resultCd === "I0000") {
            setState({
              ...state,
              errorMsgId: "",
            });
            if (res.staffNoInfoList && res.staffNoInfoList.length > 0) {
              setStaffNoInfoList(res.staffNoInfoList);
              setFormData(data);
              setOpenDelete(true);
            } else {
              const stated: any = {
                contractDate: data.contractDate, //中小企業退職共済契約締結年月日
                contractNo: data.contractNo, //共済契約者番号
                contractReason: data.contractReason, //中小企業退職共済契約締結の理由
                remark: data.remark, //備考
                tempSaveStep: resData.tempSaveStep, //最新申請状態
              };
              navigate("/SCRC050012", { state: stated });
            }
          } else {
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });
          }
        } catch (error) {
          navigate("/error");
        }
        break;
    }
  };

  const callAPI_CON014 = (
    obj: any,
    selectBtn: string
  ): Promise<IAPI_CON014_Response> => {
    return httpIAPI_CON014({
      applyId, //申請id
      tempSaveStep: selectBtn === "CONFIRM" ? 9 : 1, //最新申請状態
      contractorNo, //共済契約者番号
      contractDate: obj?.contractDate, //中小企業退職共済契約締結年月日
      contractNo: obj?.contractNo, //中小企業退職共済契約者番号
      contractReason: obj?.contractReason, //中小企業退職共済契約締結の理由
      remark: obj.remark, //備考
      receptionDate: "", // 受付日
      screenId: "SCRC050110", // 画面id
    });
  };

  /**
   * 施設一覧テーブルを作成する
   * @param res
   * @param disabled
   * @returns infoBodyList
   */
  function funInfoBodyList(
    res: any[],
    disabled: boolean,
    contractDate: string
  ) {
    let infoBodyList: any = res?.map((element: any) => [
      {
        id: element.facilityNo,
      },
      {
        children:
          (element.facilityNo ?? "") + ":" + (element.facilityName ?? ""),
        forSort: element.facilityNo,
      },
      {
        children:
          FacilityKind[element.facilityKind as keyof typeof FacilityKind],
        forSort: element.facilityKind,
      },
      {
        children: changeAmountFormat(element.joinStaffNum),
        forSort: element.joinStaffNum,
        align: "right",
      },
      {
        children: (
          <Box className="SCRC050110DisplayButton">
            <TkButton
              data-testid="SCRC050110DisplayButton"
              onClick={() => handleDisplay(element)}
              disabled={disabled}
            >
              表示
            </TkButton>
          </Box>
        ),
      },
      {
        children: (
          <Box className="SCRC050110ResisterButton">
            <TkButton
              data-testid="SCRC050110ResisterButton"
              onClick={() => handleResister(element.facilityNo)}
              disabled={disabled}
            >
              登録
            </TkButton>
            <Box className="SCRC050110ResisterButtonText">
              <Typography>
                {!!contractDate
                  ? !element.threeMonthsRetire
                    ? "不要"
                    : element.threeMonthsRetire ===
                      element.threeMonthsRetireCertificate
                    ? `完了（${element.threeMonthsRetireCertificate}人 / ${element.threeMonthsRetire}人）`
                    : `未完了（${element.threeMonthsRetireCertificate}人 / ${element.threeMonthsRetire}人）`
                  : "未完了（-人 / -人）"}
              </Typography>
            </Box>
          </Box>
        ),
      },
    ]);

    return infoBodyList ?? [];
  }

  //表示ボタン用イベント
  const handleDisplay = (facility: any) => {
    const stated: any = {
      facilityNo: facility.facilityNo,
      facilityName: facility.facilityName,
      kindCd: facility.facilityKind,
      cancelDate: contractDate,
    };

    navigate("/SCRC050111", { state: stated });
  };

  //登録ボタン用イベント
  const handleResister = (facilityNo: any) => {
    navigate("/SCRC050115", { state: { facilityNo } });
  };

  //モーダル画面の次へボタンイベント
  const handleModalNext = () => {
    setModalOpen(false);
  };

  //モーダル画面の従業状況の更新ボタンイベント
  const handleModalEmployeeStatusUpdate = () => {
    setModalOpen(false);
    setBusinessState({
      ...businessState,
      job_03: {
        ...businessState.job_03,
        applyId: applyId,
      },
    });
    navigate("/SCRC050114");
  };

  const handleDeleteDate = async () => {
    setOpenDelete(false);
    if (!staffNoInfoList) {
      return;
    }
    try {
      const res = await httpIAPI_CON030({
        contractorNo:
          state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo!
            : state.authInfo?.contractorNo!,
        staffNoInfoList,
        businessType: businessState.common?.businessType!,
        applyId: applyId,
      });
      if (res.resultCd === "I0000") {
        const stated: any = {
          contractDate: formData.contractDate!, //中小企業退職共済契約締結年月日
          contractorNo: formData.contractorNo!, //共済契約者番号
          contractReason: formData.contractReason!, //中小企業退職共済契約締結の理由
          remark: formData.remark!, //備考
          tempSaveStep: resData.tempSaveStep!, //最新申請状態
        };
        navigate("/SCRC050012", { state: stated });
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onWarningOk = () => {
    setOpenWarning(false);
    handleCallNotificationUpdate();
  };

  return (
    <Box data-testid="SCRC050110PageForTest" className="SCRC050110">
      {modalOpen ? (
        <TkDialog
          open={modalOpen}
          onSave={handleModalEmployeeStatusUpdate}
          onCancel={handleModalNext}
          cancelText={"次へ"}
          okText={"従業状況の更新"}
        >
          <TkInfoManual rule={"<"}>{infoModalMessage}</TkInfoManual>
        </TkDialog>
      ) : (
        <>
          <TkStepper
            steps={stepperData}
            activeStep={0}
            savaStep={resData?.tempSaveStep ?? 0}
          />
          <TkInfoManual>{labelids.labelid.LBLC050110_01}</TkInfoManual>
          {state.authInfo?.userType ===
            authorityUserType.userTypeNumber.KIKO && (
            <TkContractorAndNumberLine
              name="契約者（法人）名"
              no={
                businessState?.common?.contractorNo +
                ":" +
                businessState?.common?.contractorName
              }
            />
          )}
          <TkFakeTable
            ref={formRef}
            list={stateTableList}
            ruleSchema={schema}
            submitButtonGroup={[
              {
                submitButtonText: "一時保存",
                submitButtonDisabled: isBtnDisabled,
              },
              {
                submitButtonText: "次へ",
                submitButtonDisabled: nextBtnDisabled,
              },
            ]}
            buttonGroup={<TkBackButton />}
            onCheckAndSubmit={(e, index) => handleSubmit(e, index)}
          />
          <TkDialog
            open={openDelete}
            title="確認（退職(予定)年月日・異動情報(配置換え)が削除されます）"
            children={<TkInfoManual rule={"<"}>{contextText}</TkInfoManual>}
            okText="はい"
            cancelText="いいえ"
            onSave={handleDeleteDate}
            onCancel={() => setOpenDelete(false)}
          />
          <TkMessageDialog
            open={open}
            onOky={() => setOpen(false)}
            title="一時保存完了"
            contextText="　一時保存が完了しました。"
            okText="はい"
            cancelText=""
          />
          <TkMessageDialog
            open={openWarning}
            onOky={onWarningOk}
            onCancel={() => setOpenWarning(false)}
            onClose={() => setOpenWarning(false)}
            title="警告"
            contextText={TkPropertyMessageGet("TKMSG_SCR0033W")}
            okText="確認"
            cancelText="戻る"
          />
        </>
      )}
    </Box>
  );
};

export default SCRC050110;
